<div class="modal">
    <a (click)="closeDialog()" class="close"><mat-icon>close</mat-icon></a>
    <h1>Políticas</h1>
    <div class="texto" [innerHTML]="repuesta.texto">
    </div>
</div>